import { EMPTY_OBJ } from '@dadohr/shared/domainTypes/emptyConstants';
import styled from '@emotion/styled';
import React, { CSSProperties } from 'react';
import { withStoppedPropagation } from '../../helpers';
import { useTheme } from '../../themes';

export const LinkExternal: React.FC<{
  href: string;
  title?: string;
  className?: string;
  color?: 'primary';
  style?: CSSProperties;
  onClick?: () => void;
}> = ({
  href,
  title,
  children,
  className,
  color,
  style = EMPTY_OBJ,
  onClick = () => {}
}) => {
  const theme = useTheme();
  return (
    <a
      className={className}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      title={title || href}
      onClick={withStoppedPropagation(onClick, false)}
      style={
        color === 'primary'
          ? { ...style, color: theme.custom.colors.primary.main }
          : style
      }
    >
      {children || href}
    </a>
  );
};

export const LinkExternalWithEllipsis = styled(LinkExternal)`
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
